// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'send';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.124 2.864a1.115 1.115 0 0 1 1.47-1.542L16.71 8.494a.563.563 0 0 1 .003 1.002l-14.12 7.181a1.114 1.114 0 0 1-1.469-1.543l3.758-6.14Zm15.895 6.13H4.883'
  />
);

export const viewBox = '0 0 18 18';
